import { styled } from 'styled-components';

export const StyledNftSection = styled.div`
    width: 100%;

    // TODO: Remove these legacy selectors once we have
    // converted the Checkbox components to styled-components.
    .yat-checkbox__input .yat-checkbox__control {
        border-color: rgba(255, 255, 255, 0.3);
    }

    .yat-checkbox__input input:checked + .yat-checkbox__control {
        border-color: #523df1;
    }
`;

export const Rows = styled.div`
    display: grid;
    gap: 30px;
    padding-bottom: 160px;
`;

export const Columns = styled.div`
    display: flex;
    align-items: start;
`;
